import React from 'react'
import styles from './address.module.scss'
import { getFullCompany } from '../../../../../src/common/utils/getCompany'

export default function Address() {
  return (
    <div className={styles.address_footer_big_container}>
      <div className={styles.address_footer_container}>
        C/Pere de Cabrera, 16 5ª planta - 25001 Lleida
        <br />
        {`\u00A9 ${getFullCompany()} ${new Date().getFullYear()}`}
        <br />
      </div>
    </div>
  )
}
